import React from 'react';
import { BsThreeDots } from 'react-icons/bs';

import { useGetAssociationAdmins } from 'legacy/groups/hooks';
import Loader from 'legacy/common/components/layout/Loader';
import { AssociationMemberDto } from 'legacy/groups/types';
import { Avatar, AvatarBadge } from 'components/Avatar';
import MemberList from 'components/lists/MemberList';
import MembersListItem from 'components/lists/MemberList/ListItem';
import { useTranslation } from 'react-i18next';

interface Props {
  associationId: string;
  search: string;
  setSelectedMember: (member: AssociationMemberDto) => void;
}

const AdminsList = ({ associationId, search, setSelectedMember }: Props) => {
  const { t } = useTranslation(['associations']);
  const {
    isLoading,
    data,
    fetchNextPage,
    fetchPreviousPage,
    hasPreviousPage,
    hasNextPage
  } = useGetAssociationAdmins(associationId, search);

  const onSelectMember = (member: AssociationMemberDto) => () =>
    setSelectedMember(member);

  return (
    <MemberList
      title={t('members.admins')}
      description={t('members.adminsDescription')}
      onNext={fetchNextPage}
      onPrev={fetchPreviousPage}
      hasNextPage={hasNextPage}
      hasPreviousPage={hasPreviousPage}
    >
      {isLoading ? (
        <Loader isLoading />
      ) : (
        data?.map((admin) => (
          <MembersListItem
            key={admin.id}
            avatar={
              <Avatar src={admin.user.photoUrl}>
                <AvatarBadge>
                  <img src="/img/icons/shield-person-gradient.svg" />
                </AvatarBadge>
              </Avatar>
            }
            label={`${admin.user.firstName} ${admin.user.lastName}`}
            actions={
              <button
                type="button"
                aria-label="Member actions"
                onClick={onSelectMember(admin)}
              >
                <BsThreeDots size={20} />
              </button>
            }
          />
        ))
      )}
    </MemberList>
  );
};

export default AdminsList;
